import {ReactNode, useState, forwardRef, ForwardRefRenderFunction} from 'react';
import { css, cx } from '@pandacss/css';

interface Props {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    children?: ReactNode;
    smallRightPadding?: boolean;
}

const outerClass = css({
    display: 'flex',
    gap: '20px',
    alignItems: 'center',
    height: '64px',
    padding: '20px',
    borderRadius: '32px',
    backgroundColor: 'neutral.700',
    border: '1px solid',
    borderColor: 'neutral.500',

    '&.active': {
        border: '2px solid',
        borderColor: 'primary.400',
        padding: '19px',

        '&.smallRightPadding': { paddingRight: '9px' },
    },

    '&.smallRightPadding': { paddingRight: '10px' },
});

const inputClass = css({
    flex: 1,
    height: '40px',
    minWidth: 0,
    '&:focus': { outline: 'none' },
});

const ChatBarBase: ForwardRefRenderFunction<HTMLInputElement, Props> = (
    { value, onChange, placeholder, children, smallRightPadding },
    ref
) => {
    const [focused, setFocused] = useState(false);

    return (
        <div className={cx(outerClass, focused && 'active', smallRightPadding && 'smallRightPadding')}>
            <input ref={ref} className={inputClass} value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}/>
            {children}
        </div>
    );
};

const ChatBar = forwardRef(ChatBarBase);

export default ChatBar;
